import { Tooltip } from '@timelyapp/react';
import type { Props as CurrencyFormatProps } from 'components/CurrencyFormat';
import CurrencyFormat from 'components/CurrencyFormat';
import { InfoIcon } from 'components/Icons';
import React from 'react';
import styles from './MultiCurrencyWrapper.module.scss';

interface MultiCurrencyWrapperProps
  extends React.PropsWithChildren<Omit<CurrencyFormatProps, 'value'>> {
  hasMultipleCurrencies?: boolean;
  value?: number | null;
}

/**
 * Wraps a `CurrencyFormat` element or a money value with a placeholder icon and a tooltip if the
 * value is based on multiple currencies.
 */
export const MultiCurrencyWrapper = ({
  children,
  currency,
  value = null,
  animated = false,
  hasMultipleCurrencies,
  ...props
}: MultiCurrencyWrapperProps): React.ReactElement => {
  if (!hasMultipleCurrencies && children) {
    return <>{children}</>;
  }

  if (currency) {
    return children ? (
      <>{children}</>
    ) : (
      <CurrencyFormat value={value} animated={animated} currency={currency} {...props} />
    );
  }

  return (
    <Tooltip
      childrenClassName={styles.multiCurrencyTooltip}
      tooltip="Sums with multiple currencies cannot be displayed."
      fixed
    >
      <InfoIcon />
    </Tooltip>
  );
};
